import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";

export default function ProtectedRoute({ children }) {
  const { user, loading } = useAuth();
  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[#0A0A0A] text-[#F5F5F5]">
        <div className="flex items-center gap-3">
          <div className="w-3 h-3 rounded-full bg-[#FF3B30] animate-pulse" />
          <span className="text-sm font-mono uppercase tracking-widest text-[#A3A3A3]">
            Loading CricketPulse...
          </span>
        </div>
      </div>
    );
  }
  if (!user) return <Navigate to="/login" replace />;
  return children;
}
